import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './FeatureBand.css';

/**
 * One full-width front-page section per feature: the problem, what Revetall does,
 * and a drawing. On wide screens bands alternate light orange / white and switch the
 * drawing's side; on phones the drawing sits between the text and the "Se hvordan" button.
 * @param {Object} props
 * @param {{id: string, path: string, Illustration: Function}} props.feature - Entry from FEATURES
 * @param {number} props.index - Position in FEATURES, used to alternate color and side
 * @returns {JSX.Element} Feature band
 */
function FeatureBand({ feature, index }) {
  const { t } = useTranslation();
  const key = `features.${feature.id}`;
  const title = t(`${key}.title`);
  // The intro band above is light orange, so the first band is white. Every other band
  // is light orange with the drawing on the left.
  const isAlternate = index % 2 === 1;
  const { Illustration } = feature;

  return (
    <article
      className={`feature-band${isAlternate ? ' feature-band--tinted feature-band--reverse' : ''}`}
    >
      <div className="feature-band-content">
        <div className="feature-band-text">
          <h3 className="feature-band-title">{title}</h3>
          <p className="feature-band-problem">{t(`${key}.problem`)}</p>
          <p className="feature-band-value">{t(`${key}.intro`)}</p>
          <Link
            to={feature.path}
            className="button button-outline feature-band-button"
            aria-label={t('whatWeDo.seeHowLabel', { title })}
          >
            {t('whatWeDo.seeHow')} <span aria-hidden="true">→</span>
          </Link>
        </div>
        <div className="feature-band-art">
          <Illustration />
        </div>
      </div>
    </article>
  );
}

export default FeatureBand;
